import McmStagingConfig from '~/tenants/mcm/performable/staging/McmStagingConfig';
import McmJob from '~/tenants/mcm/model/McmJob';
import { FIRST_VERSION_TIMESTAMP, ZodVersionedMetadata } from '~/lib/zod';
import { TenantJobLine } from '~/lib/model';
import { Big } from 'big.js';

export default class McmStagingJob extends McmJob<typeof McmStagingConfig> {
  get performable() {
    return McmStagingConfig;
  }

  defaultValue(): ZodVersionedMetadata<(typeof McmStagingConfig)['schema']> {
    return {
      version: FIRST_VERSION_TIMESTAMP,
      photos: 1,
    };
  }

  get assignable(): boolean {
    return true;
  }

  revenueLines(): TenantJobLine[] {
    const lines: TenantJobLine[] = [];
    const photos = this.metadata.photos || 1;

    lines.push({
      id: 'photos',
      description: `Virtual Staging (${photos} photo${photos > 1 ? 's' : ''})`,
      amount: new Big(65).times(photos),
    });

    return lines;
  }

  onsite(): number {
    return 0;
  }

  get eligible(): boolean {
    return !this.buyer('crossroads');
  }

  get configurable() {
    return true;
  }
}
